var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#CFC8FF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.65 38.9977H42.9V54.5977H52.65C53.727 54.5977 54.6 53.7246 54.6 52.6477V40.9477C54.6 39.8707 53.727 38.9977 52.65 38.9977ZM39 35.0977V58.4977H52.65C55.8809 58.4977 58.5 55.8785 58.5 52.6477V40.9477C58.5 37.7168 55.8809 35.0977 52.65 35.0977H39Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7052 44.8523C50.7052 43.7754 49.8321 42.9023 48.7552 42.9023C47.6782 42.9023 46.8052 43.7754 46.8052 44.8523C46.8052 45.9293 47.6782 46.8023 48.7552 46.8023C49.8321 46.8023 50.7052 45.9293 50.7052 44.8523Z",
    fill: "#3A2CA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7052 50.7023C50.7052 49.6254 49.8321 48.7523 48.7552 48.7523C47.6782 48.7523 46.8052 49.6254 46.8052 50.7023C46.8052 51.7793 47.6782 52.6523 48.7552 52.6523C49.8321 52.6523 50.7052 51.7793 50.7052 50.7023Z",
    fill: "#3A2CA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.35 58.5C22.1191 58.5 19.5 55.8809 19.5 52.65V25.35C19.5 22.1191 22.1191 19.5 25.35 19.5H37.05C40.2809 19.5 42.9 22.1191 42.9 25.35V58.5H25.35ZM25.35 23.4H37.05C38.127 23.4 39 24.273 39 25.35V54.6H35.1V52.65C35.1 51.573 34.227 50.7 33.15 50.7H29.25C28.173 50.7 27.3 51.573 27.3 52.65V54.6H25.35C24.273 54.6 23.4 53.727 23.4 52.65V25.35C23.4 24.273 24.273 23.4 25.35 23.4Z",
    fill: "#ffbb00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1552 27.2988C34.2321 27.2988 35.1052 28.1719 35.1052 29.2488C35.1052 30.3258 34.2321 31.1988 33.1552 31.1988H29.2552C28.1782 31.1988 27.3052 30.3258 27.3052 29.2488C27.3052 28.1719 28.1782 27.2988 29.2552 27.2988H33.1552Z",
    fill: "#3A2CA0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1552 35.0988C34.2321 35.0988 35.1052 35.9719 35.1052 37.0488C35.1052 38.1258 34.2321 38.9988 33.1552 38.9988H29.2552C28.1782 38.9988 27.3052 38.1258 27.3052 37.0488C27.3052 35.9719 28.1782 35.0988 29.2552 35.0988H33.1552Z",
    fill: "#3A2CA0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1052 44.8488C35.1052 43.7719 34.2321 42.8988 33.1552 42.8988H29.2552C28.1782 42.8988 27.3052 43.7719 27.3052 44.8488C27.3052 45.9258 28.1782 46.7988 29.2552 46.7988H33.1552C34.2321 46.7988 35.1052 45.9258 35.1052 44.8488Z",
    fill: "#3A2CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateIcon);
export default __webpack_public_path__ + "static/media/corporate-icon.0408d449e01f040dda9d4a8840055c79.svg";
export { ForwardRef as ReactComponent };